/** Onboarding completion state (per Cognito user, survives sessionStorage clears). */

const doneKey = (userKey) => `onboarding_done_${userKey}`;
const submittedKey = (userKey) => `onboarding_submitted_${userKey}`;
const tenantKey = (userKey) => `tenant_id_${userKey}`;
const tenantNameKey = (userKey) => `tenant_name_${userKey}`;

export const TENANT_STATUS_ACTIVE = "active";
export const TENANT_STATUS_PENDING_APPROVAL = "pending_approval";
export const TENANT_STATUS_ONBOARDING = "onboarding";

export const ADMIN_CONTACT_EMAIL = "victor@tagnize.com";

export const userKeyFromClaims = (claims = {}) => claims.sub || claims.email || null;

export const getTenantStatusFromClaims = (claims = {}) =>
  claims["custom:tenant_status"] || claims.tenant_status || null;

export const markOnboardingComplete = (userKey, tenantId, tenantName) => {
  if (!userKey || !tenantId) return;
  localStorage.setItem(doneKey(userKey), "true");
  localStorage.setItem(tenantKey(userKey), tenantId);
  if (tenantName) {
    localStorage.setItem(tenantNameKey(userKey), tenantName);
  }
  sessionStorage.removeItem("onboarding_profile");
  sessionStorage.removeItem("onboarding_password");
  sessionStorage.removeItem("onboarding_email_confirmed");
  sessionStorage.removeItem("onboarding_tenant_id");
  sessionStorage.removeItem("onboarding_tenant_name");
  sessionStorage.removeItem("onboarding_ingest_email");
  sessionStorage.removeItem("onboarding_contact_done");
};

export const markOnboardingSubmitted = (userKey, tenantId, tenantName) => {
  if (!userKey || !tenantId) return;
  localStorage.removeItem(doneKey(userKey));
  localStorage.setItem(submittedKey(userKey), "true");
  localStorage.setItem(tenantKey(userKey), tenantId);
  if (tenantName) {
    localStorage.setItem(tenantNameKey(userKey), tenantName);
  }
  sessionStorage.removeItem("onboarding_profile");
  sessionStorage.removeItem("onboarding_password");
  sessionStorage.removeItem("onboarding_email_confirmed");
  sessionStorage.removeItem("onboarding_contact_done");
};

export const isOnboardingComplete = (userKey) =>
  Boolean(userKey && localStorage.getItem(doneKey(userKey)) === "true");

export const hasSubmittedForApproval = (userKey) =>
  Boolean(userKey && localStorage.getItem(submittedKey(userKey)) === "true");

/** Wizard finalizado y tenant activo (acceso a la app). */
export const hasCompletedOnboarding = (userKey) =>
  Boolean(userKey) && isOnboardingComplete(userKey);

export const getStoredTenantId = (userKey) =>
  userKey ? localStorage.getItem(tenantKey(userKey)) : null;

export const getStoredTenantName = (userKey) =>
  userKey ? localStorage.getItem(tenantNameKey(userKey)) : null;

export const clearOnboardingState = (userKey) => {
  if (!userKey) return;
  localStorage.removeItem(doneKey(userKey));
  localStorage.removeItem(submittedKey(userKey));
  localStorage.removeItem(tenantKey(userKey));
  localStorage.removeItem(tenantNameKey(userKey));
};
